// @flow

import React from 'react';
import { withErrorEmptyComponent } from '../../../emptyComponent';
import type { ACFFormField } from '../../../../types';
import type { ElementMapping } from './types';

type Props = {
  element: ?ACFFormField,
  elementMapping: ElementMapping,
};

export default ({ element, elementMapping }: Props) => {
  if (!element) {
    return null;
  }

  // Get React component or fallback to EmptyComponent if there is no match
  const EmptyComponent = withErrorEmptyComponent(`Couldn't map ${element.acf_fc_layout} to a component in formElement`);
  const Element = elementMapping[element.acf_fc_layout] || EmptyComponent;

  return (
    <Element
      {...element}
    />
  );
};
